module.exports = __webpack_public_path__ + "img/cookies_bagt.48e495ab.jpg";